module.exports = __webpack_public_path__ + "images/img_4_2-ad5b3c3e29.png";